
























import { TeipNotifications } from '@/util/teipNotifications';
import Vue from 'vue';
import BranchInfo from './Branch.vue';
import FirstStep from './FirstStep.vue';
import SecondStep from './SecondStep.vue';

export default Vue.extend({
  name: 'TransferModal',
  components: {
    BranchInfo,
    FirstStep,
    SecondStep,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    step: 1,
  }),
  computed: {
    syncedViewDetails: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    succesTransfer() {
      this.syncedViewDetails = false;
      this.step = 1;
      const notification = new TeipNotifications();

      notification.success('Transferencia realizada con éxito');
    },
  },
});
